export default {
  backendUrl: 'https://hivetrak-backend-prod-yxzb7ir75q-uc.a.run.app',
  STRIPE_PK:
    'pk_live_51L0TmeHwK55b946DJQ9X9icqPSdHekzNjElF0mA1gMdDIXDMRUlRNByDSTI74oofRwcgRUZZJk3jsCmSntlQ6H2D00TBdOPThJ',
  GOOGLE_API_KEY: 'AIzaSyAD6k-enDKy_XtloUPNWjTghLF8omqDlm8',
  MAPBOX_API_KEY:
    'pk.eyJ1Ijoicml2ZXJjaXR5dGVjaCIsImEiOiJjbDdrdGZkMjYxYnF1M25xcHlxNDN1YTJiIn0.abygEOLWX_M44PhcTwV0kw',
};
